import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import SliderBtn from "../../componets/SliderBtn";

const caseStudies = [
  {
    title: "MTJ Clothing Store",
    image: "/assets/mtjBanner.png",
    link: "#",
  },
  {
    title: "Zeen Clothing Store",
    image: "/assets/zeenBanner.png",
    link: "#",
  },
  {
    title: "MTJ Clothing Store",
    image: "/assets/mtjBanner.png",
    link: "#",
  },
  {
    title: "Zeen Clothing Store",
    image: "/assets/zeenBanner.png",
    link: "#",
  },
];

const Section7 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    rows: 1,
    slidesPerRow: 1,

    nextArrow: (
      <SliderBtn
        direction="next"
        position={{ background: "#cd2122", right: "-10px", opacity: "1" }}
      />
    ),
    prevArrow: (
      <SliderBtn
        direction="prev"
        position={{ background: "#cd2122", left: "-10px", opacity: "1" }}
      />
    ),

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false, // mobile pe arrows hide
          dots: true,    // dots show
        },
      },
    ],
  };

  return (
    <section className="container-1280 py-10 md:py-[60px] xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto">
      
      {/* Heading */}
      <h2 className="mb-6 text-[26px] md:text-[30px] font-bold text-center md:text-left">
        Case Studies
      </h2>

      {/* Slider */}
      <div className="w-full mx-auto">
        <Slider {...settings}>
          {caseStudies.map((study, index) => (
            <div key={index} className="px-2 md:px-4">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">

                {/* Image */}
                <img
                  src={study.image}
                  alt={study.title}
                  className="w-full h-[180px] md:h-[250px] object-cover transition-transform duration-300 hover:scale-105"
                />

                {/* Content */}
                <div className="p-3 md:p-4">
                  <h3 className="text-lg md:text-2xl font-medium">
                    {study.title}
                  </h3>

                  <Link
                    to={"/case-studies"}
                    className="inline-block mt-2 text-sm md:text-base text-red-500 border border-black rounded px-3 py-1 md:px-4 md:py-2 hover:bg-red-500 hover:text-white transition"
                  >
                    View Case Study
                  </Link>
                </div>

              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Bottom Line */}
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </section>
  );
};

export default Section7;